import { Injectable } from '@angular/core';
import { config } from '../../config/appConfig';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import {
  IProfileUploadResponse,
  IUploadFileResponse,
} from '../models/mediaDelivery';

enum MediaDeliveryEndPoints {
  bookUpload = '/book/upload', // Uploads Book Related Resources
  chapterUpload = '/chapter/upload', // Uploads Chapter Related Resources
  download = '/download', // Download Media Files
  profileUpload = '/profile/upload', // Uploads Profile Related Resources
  sectionUpload = '/section/upload', // Uploads Section Related Resources
  mediaUpload = '/upload', // Uploads Non Categorized Resources
}

@Injectable({
  providedIn: 'root',
})
export class MediaDeliveryService {
  httpService: HttpService = new HttpService(config.mediaDeliveryService);

  downloadMediaFile(fileUrl: string): Observable<any> {
    let link = fileUrl;
    if (fileUrl.includes(config.mediaDeliveryService)) {
      link = fileUrl.replace(config.mediaDeliveryService, '');
    }
    return this.httpService.downloadMedia(
      config.mediaDeliveryService +
        MediaDeliveryEndPoints.download +
        '?fileUrl=' +
        encodeURIComponent(link),
    );
  }

  getDownloadUrl(fileUrl: string): string {
    return (
      config.mediaDeliveryService +
      MediaDeliveryEndPoints.download +
      '?fileUrl=' +
      encodeURIComponent(fileUrl)
    );
  }

  profileUpload(file: File): Observable<IProfileUploadResponse> {
    return this.httpService.uploadFile(
      MediaDeliveryEndPoints.profileUpload,
      file,
    );
  }

  bookMediaUpload(file: File): Observable<IProfileUploadResponse> {
    return this.httpService.uploadFile(MediaDeliveryEndPoints.bookUpload, file);
  }

  getFullUrl(fileUrl: string): string {
    return (
      config.mediaDeliveryService +
      '/download?fileUrl=' +
      encodeURIComponent(fileUrl)
    );
  }

  getRawURl(fileUrl: string): string {
    if (fileUrl.includes(config.mediaDeliveryService)) {
      return fileUrl.replace(config.mediaDeliveryService, '');
    }
    return fileUrl;
  }

  chapterMediaUpload(file: File): Observable<IUploadFileResponse> {
    return this.httpService.uploadFile(
      MediaDeliveryEndPoints.chapterUpload,
      file,
    );
  }

  sectionMediaUpload(file: File): Observable<IProfileUploadResponse> {
    return this.httpService.uploadFile(
      MediaDeliveryEndPoints.sectionUpload,
      file,
    );
  }
}
